import { render, staticRenderFns } from "./CancellationRequest.vue?vue&type=template&id=6240c87c&scoped=true&"
import script from "./CancellationRequest.vue?vue&type=script&lang=js&"
export * from "./CancellationRequest.vue?vue&type=script&lang=js&"
import style0 from "./CancellationRequest.vue?vue&type=style&index=0&id=6240c87c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6240c87c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6240c87c')) {
      api.createRecord('6240c87c', component.options)
    } else {
      api.reload('6240c87c', component.options)
    }
    module.hot.accept("./CancellationRequest.vue?vue&type=template&id=6240c87c&scoped=true&", function () {
      api.rerender('6240c87c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CancellationRequest.vue"
export default component.exports